import { Components, Theme } from '@mui/material/styles';

export const cardTheme: Components<Theme>['MuiCard'] = {
  styleOverrides: {
    // Shadow only replaces the default elevation (1); call sites that
    // pass an explicit `elevation` keep MUI's shadow for that level.
    root: ({ theme, ownerState }) => ({
      borderRadius: theme.shape.borderRadius,
      ...(ownerState.variant !== "outlined" &&
        (ownerState.elevation ?? 1) === 1 && {
        boxShadow: theme.customShadows.card,
      }),
    }),
  },
};
